import { Reveal } from "./Reveal";
import { siteConfig } from "../../data/content";
import { useLang } from "../../i18n/LanguageContext";

export const About = () => {
  const { t } = useLang();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="scroll-mt-24 bg-[#F4F3EF] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        <Reveal>
          <p className="text-xs md:text-sm font-medium tracking-[0.3em] uppercase text-[#5C5C59] mb-6">
            {t.about.overline}
          </p>
          <h2 className="font-serif text-3xl md:text-5xl leading-tight tracking-tight text-[#1A1C19]">
            {t.about.title}
          </h2>
          <div className="mt-8 space-y-6 text-base md:text-lg leading-relaxed text-[#5C5C59]">
            <p>{t.about.p1}</p>
            <p>{t.about.p2}</p>
            <p>{t.about.p3}</p>
          </div>
          <p className="mt-8 border-l-2 border-[#B5A68B] pl-6 font-serif text-xl md:text-2xl leading-snug text-[#1A1C19]">
            {t.about.quote}
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="relative overflow-hidden">
            <img
              src={siteConfig.images.about}
              alt="Modern residential architecture with natural materials"
              className="w-full h-[420px] md:h-[600px] object-cover transition-transform [transition-duration:1200ms] ease-out hover:scale-105"
              loading="lazy"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
